import { FC } from 'react'
import IconFilter from 'remixicon/icons/System/filter-3-line.svg?react'
import IconSearch from 'remixicon/icons/System/search-line.svg?react'

export interface OrderTableEmptyProps {
  isEmpty?: boolean
  isLoading?: boolean
  isVisible?: boolean
  mode?: 'filter' | 'search'
}

const MESSAGES: Record<
  string,
  {
    description: string
    icon: TSvgIconComponent
    title: string
  }
> = {
  filter: {
    icon: IconFilter,
    title: 'По вашему запросу ничего не нашлось',
    description: 'Попробуйте смягчить условия фильтрации, и результат появится'
  },
  search: {
    icon: IconSearch,
    title: 'Заявок с таким номером не найдено',
    description:
      'Поиск работает по номеру заявки или трек-номеру отправления: проверьте правильность написания или попробуйте другой запрос'
  }
}

const OrderEmptyMessage: FC<{
  description: string
  icon: TSvgIconComponent
  title: string
}> = ({ icon: Icon, title, description }) => (
  <>
    <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-container">
      <Icon className="text-on-primary-container" size="lg" />
    </div>
    <div className="max-w-[312px] text-center md:max-w-full md:text-left">
      <div className="text-title-md">{title}</div>
      <div className="text-body-md">{description}</div>
    </div>
  </>
)

export const OrderTableEmpty: FC<OrderTableEmptyProps> = ({
  isEmpty = false,
  isLoading = false,
  isVisible = false,
  mode = 'empty'
}) => {
  if (!isVisible || isLoading) return null

  if (isEmpty) {
    return (
      <div className="mb-0 p-8 text-center text-body-sm text-on-surface-variant shadow-inherit max-[960px]:shadow-[0_-1px_0_rgba(0,0,0,0.12)] md:p-14 md:text-body-md min-[960px]:mb-10 min-[960px]:shadow-[inset_0_-1px_0_rgba(0,0,0,0.12)]">
        Заявок нет
      </div>
    )
  }

  const message = MESSAGES[mode]

  return (
    <div className="mt-6 grid max-w-[819px] grid-cols-1 items-center justify-items-center gap-6 py-6 pl-6 pr-16 md:mt-0 md:grid-cols-[64px_auto] md:justify-items-start">
      <OrderEmptyMessage {...message} />
    </div>
  )
}
